import { render, staticRenderFns } from "./Taber.vue?vue&type=template&id=15d367ac&"
import script from "./Taber.vue?vue&type=script&lang=js&"
export * from "./Taber.vue?vue&type=script&lang=js&"
import style0 from "./Taber.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports